import Vue from 'vue'
import Vuex from 'vuex'
import userService from './service/user'
import config from "./config";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null
    },
    getters: {
        hasAuthority(state) {
            return (authority) => {
                if (!state.user) {
                    return false
                }
                return state.user.authorities.findIndex(item => item.authority === authority) !== -1
            }
        },
        hasAnyAuthority(state) {
            return (...authorities) => {
                if (!state.user) {
                    return false
                }
                return state.user.authorities.findIndex(item => authorities.indexOf(item.authority)!==-1) !== -1
            }
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        }
    },
    actions: {
        async fetchUser({commit}) {
            const response = await userService.getUserInfo()
            commit('setUser', response.data)
        },
        async logout({commit}) {
            commit('setUser', null)
            const logoutUrl = config.backendUrl + '/logout?redirect=' + encodeURIComponent(document.location.origin +
                document.location.pathname)
            document.location.replace(logoutUrl)
        }
    }
})
